export default class ResumeTimelineItem {
  constructor({name, place, date, link, icon, description = ''}) {
    this.name = name;
    this.place = place;
    this.date = date;
    this.link = link;
    this.icon = icon;
    this.description = description;
  }
}
